import { useState, useEffect } from "react";
import WorkerServices from "../../services/Worker.services";

function useSearchInTree(searchedText, treeData, categoryOnly) {
    const [searchedData, setsearchedData] = useState([]);
    const [loadingSearch, setLoadingSearch] = useState(false);

    useEffect(() => {
        let timeout = null;
        if (searchedText) {
            setLoadingSearch(true);
            timeout = setTimeout(() => {
                WorkerServices.searchInTreeCategory([[...treeData], searchedText.toLocaleLowerCase(), categoryOnly]).then((result) => {
                        setsearchedData(result);
                        setLoadingSearch(false);
                    });
            }, 1000);
        } else {
            setsearchedData([]);
        }

        return () => {
            if (timeout) clearTimeout(timeout);
            setLoadingSearch(false);
        };
    }, [searchedText, treeData, categoryOnly]);

    return { loadingSearch, searchedData };
}

export default useSearchInTree;
